module.exports = __webpack_public_path__ + "img/reddit.9b59b973.svg";